/* Vigilo tema betikleri */
(function () {
  'use strict';
  var V = window.vigilo || { routes: { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' }, cartDrawer: true };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function formatMoney(cents) {
    var fmt = V.moneyFormat || '{{amount}} TL';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* ---------- Mobil menü ---------- */
  var menu = $('[data-mobile-menu]');
  function toggleMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) toggleMenu(true);
    if (e.target.closest('[data-menu-close]')) toggleMenu(false);
  });

  /* ---------- Sepet çekmecesi ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lockScroll(true);
    startCountdown();
    var c = d.querySelector('[data-drawer-close].icon-btn'); if (c) c.focus({ preventScroll: true });
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lockScroll(false);
  }
  function renderDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#CartDrawer'), current = drawer();
    if (fresh && current) {
      var wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
  }
  function updateBubble(count) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
  }
  function refreshCartCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateBubble(c.item_count); return c; });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && V.cartDrawer && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    var rmBtn = e.target.closest('[data-line-remove]');
    if (qtyBtn || rmBtn) {
      var line = rmBtn ? rmBtn.getAttribute('data-line-remove') : qtyBtn.closest('[data-line]').getAttribute('data-line');
      var qty = rmBtn ? 0 : parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      changeLine(parseInt(line, 10), Math.max(0, qty));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); } });

  function changeLine(line, quantity) {
    var d = drawer(); if (d) d.style.pointerEvents = 'none';
    fetch(V.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.sections) renderDrawer(res.sections['cart-drawer']);
      updateBubble(res.item_count || 0);
    }).finally(function () { if (d) d.style.pointerEvents = ''; });
  }

  var countdownTimer = null;
  function startCountdown() {
    var el = $('[data-countdown]', drawer()); if (!el) return;
    var key = 'vigilo_cart_reserve', mins = parseInt(el.getAttribute('data-countdown'), 10), end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) { end = 0; }
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    clearInterval(countdownTimer);
    var tick = function () {
      var node = $('[data-countdown]', drawer()); if (!node) return clearInterval(countdownTimer);
      var left = Math.max(0, end - Date.now()), m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
      node.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) clearInterval(countdownTimer);
    };
    tick(); countdownTimer = setInterval(tick, 1000);
  }

  /* ---------- Sepete ekle ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc]'), err = form.querySelector('[data-form-error]');
    if (!btn || btn.disabled) return;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;

    var fd = new FormData(form);
    if (V.cartDrawer && drawer()) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }

    fetch(V.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          var msg = res.body.description || res.body.message || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.';
          if (err) { err.textContent = msg; err.hidden = false; }
          return;
        }
        if (V.cartDrawer && drawer()) {
          if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']);
          refreshCartCount();
          openDrawer();
        } else {
          window.location.href = V.routes.cart_url;
        }
      })
      .catch(function () { if (err) { err.textContent = 'Bağlantı hatası. Lütfen tekrar deneyin.'; err.hidden = false; } })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Adet seçici ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]'); if (!step) return;
    var input = step.closest('[data-qty]').querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
  });

  /* ---------- Ürün sayfası ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-product-form]', section);

    /* Galeri */
    var main = $('[data-gallery-main]', section);
    if (main) {
      var slides = $$('.gallery__slide', main), dots = $$('[data-gallery-dots] button', section), thumbs = $$('[data-thumb]', section);
      var setActive = function (i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      };
      var goTo = function (i) { main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: 'smooth' }); setActive(i); };
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(main.scrollLeft / main.clientWidth)); });
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      section._goToMedia = function (mediaId) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == mediaId; });
        if (idx > -1) goTo(idx);
      };
    }

    /* Varyant seçimi */
    if (product && form && !product.has_only_default_variant) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var selected = [];
        $$('[data-option-index]:checked', form).forEach(function (inp) { selected[parseInt(inp.getAttribute('data-option-index'), 10)] = inp.value; });
        $$('[data-option-value]', form).forEach(function (s) { s.textContent = selected[parseInt(s.getAttribute('data-option-value'), 10)]; });
        var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
        updateVariant(variant);
      });
    }

    function updateVariant(variant) {
      var btn = $('[data-atc]', form), text = $('[data-atc-text]', form), sticky = $('[data-sticky-submit]', section);
      if (!variant) {
        if (btn) btn.disabled = true; if (text) text.textContent = 'Bu seçenek mevcut değil'; if (sticky) sticky.disabled = true;
        return;
      }
      $('[data-variant-id]', form).value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (sticky) sticky.disabled = !variant.available;
      if (text) text.textContent = variant.available ? (text.getAttribute('data-default') || 'Sepete Ekle') : 'Tükendi';
      $$('[data-price-wrap]', section).forEach(function (wrap) {
        var now = $('[data-price]', wrap), was = $('[data-compare]', wrap), badge = $('[data-badge]', wrap);
        if (now) now.textContent = formatMoney(variant.price);
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wrap.classList.toggle('price--sale', !!sale);
        if (was) { was.hidden = !sale; if (sale) was.textContent = formatMoney(variant.compare_at_price); }
        if (badge) { badge.hidden = !sale; if (sale) badge.textContent = '%' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + ' indirim'; }
      });
      if (variant.featured_media && section._goToMedia) section._goToMedia(variant.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    var atcText = $('[data-atc-text]', section);
    if (atcText && !$('[data-atc]', section).disabled) atcText.setAttribute('data-default', atcText.textContent.trim());

    /* Yapışkan satın al çubuğu */
    var sticky = $('[data-sticky-atc]', section), anchor = $('[data-buy-anchor]', section);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.footer');
      var anchorVisible = true, footerVisible = false;
      var sync = function () {
        var show = !anchorVisible && !footerVisible && anchor.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(function (en) { anchorVisible = en[0].isIntersecting; sync(); }).observe(anchor);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; sync(); }).observe(footer);
      var sbtn = $('[data-sticky-submit]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else $('[data-atc]', form).click(); });
    }

    /* Teslimat tarihleri (Pazar günleri atlanır) */
    var del = $('[data-delivery]', section);
    if (del) {
      var days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
      var months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      var now = new Date(), cutoff = parseInt(del.getAttribute('data-cutoff'), 10) || 15;
      var addBiz = function (d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) n--; } return r; };
      var base = new Date(now); var afterCutoff = now.getHours() >= cutoff || now.getDay() === 0;
      var shipN = parseInt(del.getAttribute('data-ship'), 10), delN = parseInt(del.getAttribute('data-deliver'), 10);
      var shipOffset = shipN + (afterCutoff ? 1 : 0);
      var ship = shipOffset === 0 ? base : addBiz(base, shipOffset);
      var arrive = addBiz(base, delN + (afterCutoff ? 1 : 0));
      var short = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];
      var label = function (d) { return short[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()].slice(0, 3); };
      $('[data-day="ship"]', del).textContent = label(ship);
      $('[data-day="deliver"]', del).textContent = label(arrive);
      var note = $('[data-delivery-note]', section);
      if (note && !afterCutoff) {
        var mins = (cutoff * 60) - (now.getHours() * 60 + now.getMinutes());
        var h = Math.floor(mins / 60), m = mins % 60;
        note.innerHTML = '<strong>' + (h > 0 ? h + ' sa ' : '') + m + ' dk</strong> içinde sipariş verirseniz, ' + (shipOffset === 0 ? 'bugün' : days[ship.getDay()]) + ' kargoda.';
        note.hidden = false;
      }
    }
  });

  /* CTA bandındaki buton satın al alanına kaydırır */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-scroll-to-buy]')) return;
    var a = document.querySelector('[data-buy-anchor]') || document.querySelector('.pdp');
    if (a) a.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Sepet sayfasından geri gelindiğinde balonu güncelle */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
})();